import React from 'react';
import {useTheme} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import BottomExpandableDrawer from '../BottomExpandableDrawer';
import {TickIcon} from '../../../utils/SvgIcons';

const FaceIdSuccess = ({visible, fullName, onClose}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={tID('FaceIdSuccess-Modal-BottomExpandableDrawer')}
      visible={visible}
      showRipple
      rippleColor={colors.accent}
      rippleIcon={<TickIcon />}
      title={`Welcome Back, ${fullName}!`}
      subtitle="You have successfully signed in."
      onClose={onClose}
    />
  );
};

export default FaceIdSuccess;
